export var BOLD = 'bold';
export var CODE = 'code';
export var COMMENT = 'comment';
export var HIGHLIGHT = 'highlight';
export var ITALIC = 'italic';
export var STRIKETHROUGH = 'strikethrough';
export var SUBSCRIPT = 'subscript';
export var SUPERSCRIPT = 'superscript';
export var UNDERLINE = 'underline';
export default {
  BOLD: BOLD,
  CODE: CODE,
  COMMENT: COMMENT,
  HIGHLIGHT: HIGHLIGHT,
  ITALIC: ITALIC,
  STRIKETHROUGH: STRIKETHROUGH,
  SUBSCRIPT: SUBSCRIPT,
  SUPERSCRIPT: SUPERSCRIPT,
  UNDERLINE: UNDERLINE
};